var SHub_Constants = {
    CCTECH_API_URL: (function () {
        return 'https://apis.cctech.co.in/';
    })(),
}

export default SHub_Constants;